import { HelpCircle, StickyNote } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

import { QuestionCardPanel } from './question-card-panel'

type Props = {
  episodeId: number
  sectionIndex: number
  question: string
  isOpen: boolean
  onOpen: () => void
  onNavigate: (key: number) => void
  /** 問いの頭の印（既定は ?） */
  icon?: React.ReactNode
  className?: string
}

/** 「読む前に頭に置く問い」の 1 つ（答えてカードにできる） */
export const QuestionItem = ({
  episodeId,
  sectionIndex,
  question,
  isOpen,
  onOpen,
  onNavigate,
  icon,
  className,
}: Props) => (
  <li className={cn('space-y-2 rounded-lg bg-muted/60 p-2.5 text-sm', className)}>
    <div className="flex gap-2">
      {icon ?? <HelpCircle className="mt-0.5 size-4 shrink-0 text-primary" />}
      <span className="flex-1 wrap-break-word">{question}</span>
    </div>
    {isOpen ? (
      <QuestionCardPanel
        episodeId={episodeId}
        sectionIndex={sectionIndex}
        question={question}
        onNavigate={onNavigate}
      />
    ) : (
      <Button variant="ghost" size="sm" className="h-7 px-2! text-xs" onClick={onOpen}>
        <StickyNote className="size-3.5" />
        答えてカードにする
      </Button>
    )}
  </li>
)
